import axios from 'axios';
import { MENUIMAGEURL } from '../index';

export const getMenuImageApi = (postData) => {
  return axios.post(MENUIMAGEURL, JSON.stringify(postData));
};
